export { default as ChosenLeasingInfo } from './chosen-leasing-info';
